import { memo } from 'react';

import { FileStatusButton, FileStatusIconErrored, FileStatusTitle } from '@air/feature-file-status/ui';
import { Close } from '@air/next-icons';

import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';

export type AssetTaggingTaskFailedPanelItemProps = {
  onClear: () => void;
};

export const AssetTaggingTaskFailedPanelItem = memo(({ onClear }: AssetTaggingTaskFailedPanelItemProps) => {
  return (
    <PaneItemTW
      avatar={<FileStatusIconErrored />}
      title={
        <FileStatusTitle data-testid="ASSET_TAGGING_TASK_FAILED_PANEL_ITEM_TITLE">
          Failed to update items
        </FileStatusTitle>
      }
      buttons={
        <FileStatusButton label="Clear" onClick={onClear}>
          <Close className="size-4" />
        </FileStatusButton>
      }
    />
  );
});

AssetTaggingTaskFailedPanelItem.displayName = 'AssetTaggingTaskFailedPanelItem';
